import { render, staticRenderFns } from "./RepayRecord.vue?vue&type=template&id=5f72fcfa&scoped=true"
import script from "./RepayRecord.vue?vue&type=script&lang=js"
export * from "./RepayRecord.vue?vue&type=script&lang=js"
import style0 from "./RepayRecord.vue?vue&type=style&index=0&id=5f72fcfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72fcfa",
  null
  
)

export default component.exports